export const environment = {
  production: false,
  accessTokenKey: 'accessToken',
  refreshTokenKey: 'refreshToken',
  serverUrl: 'https://admin-backend.api.sg.local',
  businessUrl: 'https://business.smartgas.global',
  authUrl: 'https://api.auth.dev.smartgas.global/api',
  mobileUrl: 'https://v2mobile.smartgas.global',
};
